export default [
  {
    type: 'section',
    title: 'Informasi Dasar',
    description: 'Isi informasi dasar voucher.',
  },
  {
    key: 'name',
    label: 'Nama',
    required: true,
    maxLength: 255,
  },
  {
    key: 'description',
    label: 'Deskripsi',
    type: 'quill',
  },
  {
    key: 'code',
    label: 'Kode',
    notes: 'Kosongkan untuk generate kode otomatis',
  },
  {
    key: 'type',
    label: 'Tipe Potongan',
    type: 'radio',
    required: true,
    value: 'regular',
    visibility: {
      roles: ['admin'],
    },
    options: [
      { value: 'regular', text: 'Produk' },
      { value: 'shipping', text: 'Ongkir' },
    ],
  },
  {
    key: 'media_id',
    image: 'poster',
    label: 'Gambar Voucher',
    type: 'image',
    notes: 'Gambar yang akan ditampilkan di halaman voucher',
  },

  {
    type: 'section',
    title: 'Aturan Diskon',
    description: 'Atur diskon dan batasan yang berlaku untuk voucher ini.',
  },
  {
    key: 'discount',
    label: 'Diskon',
    type: 'number',
    min: 0,
    max: 100,
    required: true,
    suffix: ' %',
    visibility: {
      callback: fields => (fields.find(f => f.key === 'type') || {}).value === 'regular',
    },
  },
  {
    key: 'max_discount',
    label: 'Maksimal Diskon',
    type: 'currency',
    min: 0,
    required: true,
    prepend: 'Rp',
  },
  {
    key: 'minimum_transaction',
    label: 'Minimum Transaksi',
    type: 'currency',
    min: 0,
    required: true,
    prepend: 'Rp',
  },

  {
    type: 'section',
    title: 'Aturan Penggunaan',
    description: 'Atur bagaimana voucher ini dapat digunakan oleh pengguna.',
  },
  {
    key: 'maximum_order',
    label: 'Maksimal Pesanan per Pengguna',
    type: 'number',
    min: 1,
    required: true,
    notes: 'Jumlah maksimal pesanan yang dapat menggunakan voucher ini per pengguna',
  },
  {
    key: 'max_usage_all',
    label: 'Maksimal Penggunaan (Semua)',
    type: 'number',
    min: 1,
    required: true,
    notes: 'Jumlah maksimal voucher dapat digunakan oleh semua pengguna',
  },

  {
    type: 'section',
    title: 'Pengaturan Tambahan',
    description: 'Pengaturan visibilitas dan status voucher.',
  },
  {
    key: 'is_active',
    label: 'Status',
    type: 'radio',
    required: true,
    value: true,
    options: [
      { value: true, text: 'Aktif' },
      { value: false, text: 'Tidak Aktif' },
    ],
  },
  {
    key: 'is_private',
    label: 'Privat',
    type: 'radio',
    value: false,
    options: [
      { value: true, text: 'Ya' },
      { value: false, text: 'Tidak' },
    ],
    notes: 'Voucher privat hanya bisa didapatkan melalui link',
  },
  {
    key: 'is_usage_visible',
    label: 'Tampilkan Penggunaan',
    type: 'radio',
    value: false,
    options: [
      { value: true, text: 'Ya' },
      { value: false, text: 'Tidak' },
    ],
    notes: 'Tampilkan jumlah penggunaan voucher kepada pengguna',
  },
  {
    key: 'for_recurring_registry_owner',
    label: 'Pemilik Registry Aktif',
    type: 'radio',
    required: true,
    value: false,
    options: [
      { value: true, text: 'Ya' },
      { value: false, text: 'Tidak' },
    ],
    notes: 'Usia registry ≥ 2 bulan, memiliki ≥ 10 produk, ≥ 5 terjual, dan usia anak ≤ 3 bulan',
  },
  {
    key: 'exclude_mos',
    label: 'Selain Miniapoly Official Store',
    type: 'radio',
    required: true,
    value: false,
    options: [
      { value: true, text: 'Ya' },
      { value: false, text: 'Tidak' },
    ],
    notes: 'Voucher dapat digunakan di semua merchant kecuali Miniapoly Official Store.',
  },
  {
    key: 'is_claimable',
    label: 'Dapat Diklaim',
    type: 'radio',
    required: true,
    value: true,
    options: [
      { value: true, text: 'Ya' },
      { value: false, text: 'Tidak' },
    ],
  },
  {
    key: 'point_required',
    label: 'Poin yang Dibutuhkan',
    type: 'number',
    required: true,
    min: 1,
    notes: 'Jumlah poin yang dibutuhkan untuk klaim voucher ini. Kosongkan jika tidak butuh poin.',
    visibility: {
      callback: fields => (fields.find(f => f.key === 'is_claimable') || {}).value === true,
    },
  },

  {
    type: 'section',
    title: 'Batasan',
    description: 'Batasi penggunaan voucher untuk kategori atau merchant tertentu.',
  },
  {
    key: 'category_id',
    label: 'Kategori',
    type: 'select',
    actionSearch: 'voucherV2/searchRootCategories',
    text: 'name',
    notes: 'Pilih kategori produk yang berlaku untuk voucher ini. Kosongkan jika berlaku untuk semua produk.',
    initialOptions: true,
  },
  {
    key: 'merchant_id',
    label: 'Merchant',
    type: 'select',
    actionSearch: 'voucherV2/searchMerchants',
    text: 'name',
    notes: 'Pilih merchant yang berlaku untuk voucher ini. Kosongkan jika berlaku untuk semua merchant.',
    initialOptions: true,
  },
]
